<template>
  <v-layout
    column
    fill-height
    class="mb-3"
  >
    <v-card-title class="mb-0 pb-0" v-if="showButtons">
      <v-btn icon :to="{ name: routeName.SUBJECT }" active-class="">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="can('edit subjects')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
             icon
             v-bind="attrs"
             v-on="on"
             @click="editSubject"
          >
            <v-icon>edit</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('EDIT') }}</span>
      </v-tooltip>
      <div>
        <v-tooltip bottom v-if="can('delete subjects')">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="deleteSubject">
              <v-icon>block</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('DELETE') }}</span>
        </v-tooltip>
      </div>
    </v-card-title>
    <v-card-title class="mt-1 pt-0">
    </v-card-title>
    <v-tabs
      :value="value"
      @change="tabChanged"
      centered
      grow
    >
      <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab dark href="#subject">
          {{ $t('SUBJECT') }}
        </v-tab>
    </v-tabs>
  </v-layout>
</template>
<script>

  export default {
    name: 'SubjectTabs',
    props: {
      zone: Object,
      value: String,
      showButtons: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      deleteSubject() {
        this.$emit('delete');
      },

      editSubject() {
        this.$emit('edit');
      },

      tabChanged(tab) {
        this.$emit('input', tab);
      },

    },
  };
</script>
